export interface BackendError {
  readonly type: string;
  readonly code: string;
  readonly arguments?: Array<unknown>;
}

export enum RestErrorType {
  SYSTEM = 'SYSTEM',
  APPLICATION = 'APPLICATION'
}

export enum RestErrorEventCategory {
  ERROR,
  SYSTEM_DOWN
}

export interface BackendErrorResponse extends BackendError {
  category: RestErrorEventCategory;
}
